import { useContext, useMemo } from 'react';
import DealBody from '@/creditflowresearch/ui/components/deals/DealListTable/components/DealBody';
import { DictionariesContext } from '@/creditflowresearch/application/Dictionaries/DictionariesContext';
import { useDictionariesContext } from '@/creditflowresearch/application/Dictionaries/v2/DictionariesContext';
import RatingAgenciesMappingService from '@/creditflowresearch/domain/RatingAgenciesMapping';
import { getRatingsMapping } from '@/creditflowresearch/ui/components/deals/DealListTable/helpers';
import IRatingsMapping from '@/creditflowresearch/domain/vo/IRatingsMapping';
import type IDeal from '@/creditflowresearch/domain/vo/IDeal';

export const DealData = ({
  rowData,
  showDealDetailsByDefault,
  // TODO: remove when the European market opening period ends
  isRestricted = false,
}: {
  rowData: IDeal,
  showDealDetailsByDefault: boolean,
  isRestricted?: boolean,
}) => {
  const legacyRatingAgenciesMap = useContext(DictionariesContext)?.ratingAgenciesMap;
  const { ratingAgencies } = useDictionariesContext();
  const ratingAgenciesMap = useMemo(
    () => legacyRatingAgenciesMap ?? RatingAgenciesMappingService.buildMap(ratingAgencies?.getAll() ?? []),
    [legacyRatingAgenciesMap, ratingAgencies],
  );
  const ratingsMapping: IRatingsMapping = getRatingsMapping(rowData, ratingAgenciesMap);

  return (
    <DealBody
      deal={ rowData }
      showDealDetailsByDefault={ showDealDetailsByDefault }
      ratingsMapping={ ratingsMapping }
      isRestricted={ isRestricted }
    />
  );
};
